<template>
  <b-row class="pr-4 pl-2">
    <b-col cols="12" :class="phone == false ? '' : 'text-center'">
      <PageTitle title="Mudar a cor" />
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-if="phone == false">
      <b-alert show variant="warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
          O layout abaixo é apenas uma simulação. No aplicativo real pode haver diferenças.
      </b-alert>
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="6" xl="6" :class="phone == false ? 'mb-3 pl-4 text-right' : 'mb-3 pl-4 text-center'">
      <div>
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=ClwafDogXZg&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=21', 
            title: 'Mudar a cor' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Mudar a cor.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </div>
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="6" xl="6" v-if="phone == true">
      <b-alert show variant="warning">
        <i class="fas fa-exclamation-triangle mr-2"></i>
          O layout abaixo é apenas uma simulação.
      </b-alert>
    </b-col>
    
    <b-col cols="12" :class="phone == false ? '' : 'text-center'">
      <b-form-group
      class="fs-20"
        label="Selecione qual plataforma deseja personalizar"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          class="ml-1"
          id="btn-radios-2"
          v-model="selected"
          :options="options"
          :aria-describedby="ariaDescribedby"
          button-variant="outline-success"     
          buttons
          
        ></b-form-radio-group>
      </b-form-group>
    </b-col>

    <b-col v-if="whatClerkPermission() && phone == true" cols="12" sm="12" md="12" lg="12" xl="12" class="mt-3" >
      <label class="font-weight-bold">
        Logo:
        <b-button
          v-if="fields.logo"
          size="sm"
          variant="danger"
          class="ml-2"
          @click="removeFile('logo')"
        >
          <i class="fas fa-trash mr-2"></i>
          REMOVER LOGO
        </b-button>
      </label>
      <div v-if="fields.logo">
        <b-img
          :src="`${getImagesAddressApp}${fields.logo}`"
          fluid
          width="70%"
        ></b-img>
      </div>

      <b-form-file
        :style="fields.logo == '' ? 'display:block' : 'display:none'"
        accept="image/*"
        browse-text="Selecionar"
        placeholder="Insira uma logo da sua empresa"
        v-model="imageSelected['logo']"
        @input="addImage('logo')"
        id="fileInputLogo"
      ></b-form-file>
    </b-col> 

    <b-col cols="12" lg="6" class="mt-3 mb-3">
      <FakeApp
        v-if="selected == 'app'"
        :style="phone == true ? 'min-height: 650px; max-height: 650px;' : 'min-height: 850px; max-height: 850px;'"
        :header-menu-color="fields.menuHeaderColor.hex8"
        :background-color="fields.backgroundColor.hex8"
        :icon-color="fields.iconColor.hex8"
        :font-color="fields.fontColor.hex8"
        :logo-app="logoApp"
        @alterar-logo-fake="handleEventoCustomizado"
      />

      <FakeWeb 
        v-else
        :style="phone == true ? 'height: 500px;' : 'height: 500px; margin-bottom: 120px;'"
        :header-menu-color="fieldsWeb.menuHeaderColor.hex8"
        :header-menu="fieldsWeb.webSmallColor.hex8"
        :icon-options-color="fieldsWeb.webMenuIconColorOptions.hex8"
        :font-color-menu-option="fieldsWeb.fontColorMenuOption.hex8"
        :background-color="fieldsWeb.backgroundColor.hex8"
        :icon-color="fieldsWeb.iconColor.hex8"
        :font-color="fieldsWeb.fontColor.hex8"
        :font-header-color="fieldsWeb.webMenuHeaderFontColor.hex8"
      />
    </b-col>

    <b-col cols="12" lg="6" v-if="whatClerkPermission()">
      <b-row>

        <b-col v-if="whatClerkPermission() && phone == false" cols="12" sm="12" md="12" lg="12" xl="12" class="mt-3" >
          <label class="font-weight-bold">
            Logo
            <b-button
              v-if="fields.logo"
              size="sm"
              variant="danger"
              class="ml-2"
              @click="removeFile('logo')"
            >
              <i class="fas fa-trash mr-2"></i>
              REMOVER LOGO
            </b-button>
          </label>
          <div v-if="fields.logo">
            <b-img
              :src="`${getImagesAddressApp}${fields.logo}`"
              fluid
              width="70%"
            ></b-img>
          </div>

          <b-form-file
            :style="fields.logo == '' ? 'display:block' : 'display:none'"
            accept="image/*"
            browse-text="Selecionar"
            placeholder="Insira uma logo da sua empresa"
            v-model="imageSelected['logo']"
            @input="addImage('logo')"
            id="fileInputLogo"
          ></b-form-file>
        </b-col>

        <b-col class="mt-3">
          <label>Cor do cabeçalho do menu</label>
          <chrome-picker v-if="selected == 'app'" v-model="fields.menuHeaderColor" />
          <chrome-picker v-else v-model="fieldsWeb.menuHeaderColor" />
        </b-col>

        <b-col class="mt-3" v-if="selected == 'web'">
          <label>Cor da fonte do cabeçalho</label>
          <chrome-picker v-model="fieldsWeb.webMenuHeaderFontColor" />
        </b-col>

        <b-col class="mt-3">
          <label>Cor dos ícones</label>
          <chrome-picker v-if="selected == 'app'" v-model="fields.iconColor" />
          <chrome-picker v-else v-model="fieldsWeb.iconColor" />
        </b-col>

        <b-col class="mt-3" v-if="selected == 'web'">
          <label>Cor do menu de opções</label>
          <chrome-picker v-model="fieldsWeb.webSmallColor" />
        </b-col>

        <b-col class="mt-3" v-if="selected == 'web'">
          <label>Cor dos ícones do menu de opções</label>
          <chrome-picker v-model="fieldsWeb.webMenuIconColorOptions" />
        </b-col>

        <b-col class="mt-3" v-if="selected == 'web'">
          <label>Cor da fonte do menu de opções</label>
          <chrome-picker v-model="fieldsWeb.fontColorMenuOption" />
        </b-col>
        
        <b-col class="mt-3">
          <label>Cor de fundo</label>
          <chrome-picker v-if="selected == 'app'" v-model="fields.backgroundColor" />
          <chrome-picker v-else v-model="fieldsWeb.backgroundColor" />
        </b-col>
        
        <b-col  class="mt-3">
          <label>Cor das fontes</label>
          <chrome-picker v-if="selected == 'app'" v-model="fields.fontColor" />
          <chrome-picker v-else v-model="fieldsWeb.fontColor" />
        </b-col>
 
        <b-col cols="12" class="mt-4">
          <div class="saveButton">
            <b-button block class="b-width" variant="success" @click="save()">
              <i class="fas fa-save mr-2"></i>
              <span v-if="selected == 'app'">Salvar App</span>
              <span v-else>Salvar Site</span>
            </b-button>
          </div>
        </b-col>  
      </b-row>

    </b-col>
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { Chrome } from 'vue-color';

import { mapActions, mapState, mapGetters } from 'vuex';
import makeToast from '../../../../mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import PageTitle from '../../../../components/PageTitle.vue';
import FakeApp from './FakeApp.vue';
import FakeWeb from './FakeWeb.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'ChangeColor',
  components: { PageTitle, 'chrome-picker': Chrome, FakeApp, FakeWeb, VideoManual },
  mixins: [makeToast],
  data() {
    return {
      loading: false,
      phone: false,
      imageSelected: {},
      fileFieldsToExclude: {},
      fields: {
        menuHeaderColor: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
        logo: ''
      },
      fieldsWeb: {
        menuHeaderColor: {},
        webMenuHeaderFontColor: {},
        webMenuIconColorOptions: {},
        webSmallColor: {},
        fontColorMenuOption: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
      },
      selected: 'app',
      logoApp: '',
      options: [
        { text: 'Ecommerce - App', value: 'app' },
        { text: 'Ecommerce - Site', value: 'web' },
      ]
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
  },
  mounted() {
    this.get();
    this.isDemoOpenModal()
  },
  methods: {
    ...mapActions('shopkeeper', ['saveCustomization', 'getCustomization', 'saveAboutCompany']),
    ...mapActions('files', ['uploadFile', 'deleteFile', 'uploadFileApiApp']),
    handleEventoCustomizado() {
      if(this.fields.logo && this.fields.logo != '' && this.fields.logo != null && this.fields.logo != undefined) {
        this.removeFile('logo');
      }

      var fileInput = document.getElementById("fileInputLogo");
      fileInput.click();
    },
    isDemoOpenModal(){
      var larguraDaTela = window.innerWidth;
      if(larguraDaTela < 700) {
        this.phone = true;
      }
      
      const isDemo = localStorage.getItem("isDemoApp");
      if(!isDemo) return

      localStorage.removeItem("isDemoApp");
      if(larguraDaTela > 750) {
        this.$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/embed/cSYt6m639R4?si=8Z6zkuuJpny6_mx4', 
          title: 'Tutorial Inicial' 
        });
      } else {
        this.$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/embed/SOweh6kyD44?si=eTy6Lowp56s3FkeY', 
          title: 'Tutorial Inicial' 
        });
      }      
    },
    addImage(key) {
      if (!this.imageSelected[key]) return;

      const formData = new FormData();
      formData.append('file', this.imageSelected[key]);

      this.$store.dispatch('startLoader');

      this.uploadFileApiApp(formData)
        .then((response) => {
          this.fields[key] = response.data.data;
          this.logoApp = response.data.data;
          this.saveLogo('Imagem inserida com sucesso!');
        })
        .catch(() => {
          this.fields[key] = '';

          this.makeToast('Oops!', 'Não foi possível inserir sua imagem, tente novamente!', 'danger');
        })
        .finally(() => {
          this.imageSelected[key] = null;
          this.$store.dispatch('endLoader');
        });
    },
    removeFile(key) {
      if (!this.fields[key]) return;

      const fileName = this.fields[key];

      this.fileFieldsToExclude[key] = fileName;

      this.fields[key] = '';
    },
    get() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getCustomization(this.userTypeId())
        .then((response) => {
          if (!response.data.data) return;

          this.fields.logo = response.data.data.projectLogo;

          this.handleColors(response.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    saveLogo(msg = '') {
      const request = {
        userId: this.userTypeId(),
        ...this.fields,
      };

      this.$store.dispatch('startLoader');

      this.saveAboutCompany(request)
        .then(() => {
          if (msg != '') {
            this.makeToast('Sucesso', msg);
          } else {
            this.makeToast('Sucesso', 'Informações sobre a empresa salvas com sucesso');
          }

          this.get();
          this.$root.$emit('valid-available-app');
          this.$root.$emit('valid-logo-about-app');
          this.$root.$emit('valid-icon-about-app');

          Object.keys(this.fileFieldsToExclude).forEach((key) => {
            this.deleteFile(this.fileFieldsToExclude[key]);
          });
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    save() {
      const request = {
        userId: this.userTypeId(),
        isWeb: false,
        icon: this.fields.icon,
        logo: this.fields.logo,
      };

      if(this.selected === "app"){
        Object.keys(this.fields).forEach((key) => {
          request[key] = this.fields[key].hex8;
        });
      }
      
      if(this.selected === "web"){
        Object.keys(this.fieldsWeb).forEach((key) => {
          request[key] = this.fieldsWeb[key].hex8;
        });
        request.isWeb = true;
      }
      
      this.$store.dispatch('startLoader');

      this.saveCustomization(request)
        .then(() => {
          this.makeToast('Sucesso', 'Cores salvas com sucesso');
          this.$root.$emit('valid-available-app');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    handleColors({ 
      menuHeaderColor,
      webSmallColor,
      fontColorMenuOption,
      backgroundColor, 
      iconColor, 
      fontColor,
      webMenuHeaderColor,
      webMenuIconColorOptions,
      webBackgroundColor,
      webIconColor,
      webFontColor,
      webMenuHeaderFontColor,
    }) {
      this.$set(this.fields.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fields.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fields.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fields.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fields.iconColor, 'hex8', iconColor);
      this.$set(this.fields.iconColor, 'hex', iconColor);

      this.$set(this.fields.fontColor, 'hex8', fontColor);
      this.$set(this.fields.fontColor, 'hex', fontColor);

      this.$set(this.fieldsWeb.menuHeaderColor, 'hex8', webMenuHeaderColor);
      this.$set(this.fieldsWeb.menuHeaderColor, 'hex', webMenuHeaderColor);

      this.$set(this.fieldsWeb.webMenuIconColorOptions, 'hex8', webMenuIconColorOptions);
      this.$set(this.fieldsWeb.webMenuIconColorOptions, 'hex', webMenuIconColorOptions);

      this.$set(this.fieldsWeb.webSmallColor, 'hex8', webSmallColor);
      this.$set(this.fieldsWeb.webSmallColor, 'hex', webSmallColor);

      this.$set(this.fieldsWeb.fontColorMenuOption, 'hex8', fontColorMenuOption);
      this.$set(this.fieldsWeb.fontColorMenuOption, 'hex', fontColorMenuOption);

      this.$set(this.fieldsWeb.backgroundColor, 'hex8', webBackgroundColor);
      this.$set(this.fieldsWeb.backgroundColor, 'hex', webBackgroundColor);

      this.$set(this.fieldsWeb.iconColor, 'hex8', webIconColor);
      this.$set(this.fieldsWeb.iconColor, 'hex', webIconColor);

      this.$set(this.fieldsWeb.fontColor, 'hex8', webFontColor);
      this.$set(this.fieldsWeb.fontColor, 'hex', webFontColor);

      this.$set(this.fieldsWeb.webMenuHeaderFontColor, 'hex8', webMenuHeaderFontColor);
      this.$set(this.fieldsWeb.webMenuHeaderFontColor, 'hex', webMenuHeaderFontColor);
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.CUSTOMIZACAO_COR);
  
        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true ;
    }
  },
};
</script>

<style scoped>
.widt-text{
  width: 390px;
}
.b-width {
  width: 90%;
  margin-left: x;
}

@media (min-width: 768px) {
  .alertText {
    position: relative;
    bottom: 90px;
  }

  .fakeStyle {
    position: relative;
    bottom: 90px;
  }

  .saveButton {
    display: flex;
    height: 50px;
  }
}
</style>